import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledSelect, YearSelectorProps } from '../../utils';

const YearSelector: React.FC<YearSelectorProps> = ({ years = [], currentYear, onYearChange }) => {

    let yearsOption = [...years];

    if (yearsOption.length === 0) {
        yearsOption = [currentYear];
    };

    return (
        <span>
            <label htmlFor="application_year">
                <FormattedMessage id="cap.applications.header.applicationYear" />
            </label>

            <StyledSelect id="application_year" value={currentYear} onChange={onYearChange}>
                {yearsOption?.map((year, index) => (
                    <option key={index} value={year}>
                        {year}
                    </option>
                ))}
            </StyledSelect>
        </span>
    );
};
export default YearSelector;
